import { render, staticRenderFns } from "./war_jcj_report.vue?vue&type=template&id=22031354&scoped=true"
import script from "./war_jcj_report.vue?vue&type=script&lang=js"
export * from "./war_jcj_report.vue?vue&type=script&lang=js"
import style0 from "./war_jcj_report.vue?vue&type=style&index=0&id=22031354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22031354",
  null
  
)

export default component.exports